import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: [
        ['manor', 0.78],
        ['sail', 0.22],
      ],
      d: 'M-4,-4h1v0.5h-1zM-4,-3.5h0.5v0.5h-0.5zM-2.5,-3.5h0.5v1h-0.5zM-4,-3h1v0.5h-1zM-1,-3h1v0.5h-1zM-4,-2.5h2v0.5h-2zM0.5,-2.5h0.5v0.5h-0.5zM-4,-2h1v0.5h-1zM0,-2h1v0.5h-1zM-4,-1.5h1.5v0.5h-1.5zM0.5,-1.5h0.5v0.5h-0.5zM-3.5,-1h1v0.5h-1zM-3,-0.5h0.5v1.5h-0.5zM-0.5,-0.5h0.5v1h-0.5zM0.5,-0.5h0.5v1.5h-0.5zM0,1h1v0.5h-1z',
    },
    {
      paint: [
        ['manor', 0.76],
        ['shadow', 0.24],
      ],
      d: 'M3.5,-4h0.5v1.5h-0.5zM2,-3.5h0.5v0.5h-0.5zM1,-3h0.5v1.5h-0.5zM2.5,-2.5h1.5v0.5h-1.5zM2,-2h2v0.5h-2zM0,-1.5h0.5v0.5h-0.5zM1,-1.5h3v0.5h-3zM-4,-1h0.5v0.5h-0.5zM1.5,-1h2.5v0.5h-2.5zM1,-0.5h3v0.5h-3zM1,0h2v0.5h-2zM1,0.5h0.5v1.5h-0.5z',
    },
    {
      paint: 'roofA',
      d: 'M-1,-8h2.5v0.5h-2.5zM-2,-7.5h3.5v0.5h-3.5zM-1,-7h2.5v0.5h-2.5zM2.5,-7h0.5v0.5h-0.5zM0,-6.5h1.5v0.5h-1.5zM2.5,-6.5h1v0.5h-1zM0,-6h4v0.5h-4zM0,-5.5h4.5v0.5h-4.5zM0.5,-5h4v0.5h-4zM0.5,-4.5h3v0.5h-3zM0.5,-4h2v0.5h-2zM1,-3.5h0.5v0.5h-0.5zM-2,-2.5h1.5v0.5h-1.5zM-2.5,-2h2.5v0.5h-2.5zM-2,-1.5h2v0.5h-2zM-1.5,-1h1v0.5h-1z',
    },
    {
      paint: [
        ['roofA', 0.78],
        ['sail', 0.22],
      ],
      d: 'M1.5,-8h0.5v2h-0.5zM-2.5,-7.5h0.5v0.5h-0.5zM-3,-7h2v0.5h-2zM-3.5,-6.5h3.5v1h-3.5zM-4,-5.5h4v0.5h-4zM-4.5,-5h5v0.5h-5zM-4,-4.5h4.5v0.5h-4.5zM3.5,-4.5h0.5v0.5h-0.5zM-2.5,-4h3v0.5h-3zM2.5,-4h0.5v0.5h-0.5zM-1,-3.5h2v0.5h-2zM1.5,-3.5h0.5v0.5h-0.5zM-0.5,-2.5h0.5v0.5h-0.5zM-2.5,-1.5h0.5v0.5h-0.5zM-0.5,-1h0.5v0.5h-0.5z',
    },
    {
      paint: 'chimney',
      d: 'M2,-8h1v1h-1zM2,-7h0.5v1h-0.5zM-3.5,-0.5h0.5v0.5h-0.5zM-2,0.5h2v1h-2z',
    },
    {
      paint: 'wallShade',
      d: 'M1.5,-8.5h1.5v0.5h-1.5zM-3,-4h0.5v0.5h-0.5zM3,-4h0.5v0.5h-0.5zM-3.5,-3.5h0.5v0.5h-0.5zM-2,-3.5h0.5v1h-0.5zM2.5,-3.5h0.5v0.5h-0.5zM0.5,-3h0.5v0.5h-0.5zM2,-3h1v0.5h-1zM2,-2.5h0.5v0.5h-0.5zM-3,-2h0.5v0.5h-0.5zM1.5,-2h0.5v0.5h-0.5zM0,-1h1.5v0.5h-1.5zM-2.5,0.5h0.5v0.5h-0.5zM-3,1h1v0.5h-1zM-3,1.5h4v0.5h-4zM-1.5,2h1.5v0.5h-1.5z',
    },
    {
      paint: 'lanternGlow',
      d: 'M-3,-3.5h0.5v1h-0.5zM-1.5,-3.5h0.5v1h-0.5zM3,-3.5h0.5v1h-0.5zM0,-3h0.5v1h-0.5zM1.5,-3h0.5v1h-0.5z',
    },
    { paint: 'trunk', d: 'M-2,-1h0.5v0.5h-0.5zM-2,-0.5h1.5v1h-1.5z' },
    { paint: 'wall', d: 'M-2.5,-1h0.5v1.5h-0.5zM0,-0.5h0.5v1.5h-0.5z' },
    {
      paint: 'manorGarden',
      d: 'M-4.5,-1h0.5v0.5h-0.5zM-4.5,-0.5h1v0.5h-1zM-4.5,0h1.5v0.5h-1.5zM3,0h1.5v0.5h-1.5zM-4,0.5h1v0.5h-1zM1.5,0.5h3v0.5h-3zM1.5,1h2.5v0.5h-2.5zM1.5,1.5h1.5v0.5h-1.5z',
    },
  ],
  pixels: 308,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
